import { render } from "./ActiveOrderCardShimmer.vue?vue&type=template&id=03dacece"
import script from "./ActiveOrderCardShimmer.vue?vue&type=script&lang=js"
export * from "./ActiveOrderCardShimmer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__